var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitters(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_659_131264)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.43457,
    y: 0.227539,
    width: 36.0651,
    height: 36.0651,
    rx: 18.0325,
    fill: "#1C1C1C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6124 14.466C25.1028 14.6918 24.5622 14.84 24.0087 14.9057C24.5853 14.5601 25.0279 14.0129 25.2364 13.3609C24.6883 13.6862 24.0887 13.9153 23.4634 14.0385C22.954 13.4959 22.2284 13.1567 21.4253 13.1567C19.8833 13.1567 18.6331 14.4069 18.6331 15.9488C18.6331 16.1677 18.6578 16.3807 18.7054 16.5852C16.3849 16.4687 14.3275 15.3571 12.9503 13.6678C12.71 14.0802 12.5723 14.5599 12.5723 15.0715C12.5723 16.0402 13.0653 16.8948 13.8145 17.3956C13.3711 17.3817 12.9374 17.2619 12.5498 17.0463C12.5496 17.058 12.5496 17.0697 12.5496 17.0814C12.5496 18.4342 13.512 19.5628 14.7893 19.8193C14.3781 19.9311 13.9469 19.9475 13.5284 19.8671C13.8837 20.9764 14.9149 21.7836 16.1366 21.8062C15.1811 22.555 13.9771 23.0014 12.669 23.0014C12.4436 23.0014 12.2214 22.9882 12.0029 22.9624C13.2386 23.7546 14.7062 24.2169 16.283 24.2169C21.4188 24.2169 24.2272 19.9623 24.2272 16.2726C24.2272 16.1515 24.2246 16.0311 24.2191 15.9114C24.7658 15.5162 25.2376 15.0268 25.6124 14.466Z",
    fill: "url(#paint0_linear_659_131264)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_659_131264",
    x: -4.56543,
    y: -4.77246,
    width: 46.0654,
    height: 46.0649,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_659_131264"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_659_131264",
    result: "effect2_innerShadow_659_131264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_659_131264",
    x1: 18.8077,
    y1: 11.1659,
    x2: 18.8077,
    y2: 25.9865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitters);
export default __webpack_public_path__ + "static/media/twitters.bb9e97df7246e885cdd01dfdd6cd7cac.svg";
export { ForwardRef as ReactComponent };